import { render, staticRenderFns } from "./ReportesComponent.vue?vue&type=template&id=01dd5d55"
import script from "./ReportesComponent.vue?vue&type=script&lang=js"
export * from "./ReportesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports